import React from 'react'
import IconBadge from '@/components/UI/Badge/IconBadge';
import CustomTab from '@/components/UI/Tabs/CustomTab';
import Background from '../Paper/Background';

const SectionCards = ({title, subtitle, icon, children}) => {
    return (
        <Background>
            <div className="flex flex-col gap-4 pl-6 pr-6 pt-6 pb-0">
               {icon && <IconBadge icon={icon} /> }
                <div className=" pb-4 flex flex-col gap-1">
                    <p className="text-lg text-[#121212] font-semibold m-0">
                        {title}
                    </p>
                    <p className="text-[#6B7F93] font-medium text-sm m-0">
                        {subtitle}
                    </p>
                </div>
            </div>

            {/* HR with stronger border */}
            <hr className="border-t-1 border-[#8d8d8d] mb-0" />

            {/* Custom tabs */}
            {children}
        </Background>
    )
}

export default SectionCards
